import type {
  ClientWiseUserTimeSheetType,
  TimeSheetType,
  UserScheduledHoursDataType,
} from "@/redux/timeSheet/timeSheetType";

export const initialState: TimeSheetType = {
  fetching: false,
  message: null,
  error: null,
  success: null,
  statusCode: null,
  userViewTimeSheetReportFetching: false,
  userViewTimeSheetStatusCode: null,
  userViewTimeSheetSuccess: null,
  userViewTimeSheetError: null,
  userViewTimeSheetMessage: null,
  timeSheetData: [],
  timeSheetReportDataList: [],
  timeSheetReportCalenderDataList: [],
  timeSheetReportTotalCount: "",
  totalTime: 0,
  reportTotalTime: 0,
  reportTotalBillableTime: 0,
  reportTotalNonBillableTime: 0,
  unfilledTimesheetCount: 0,
  unfilledTimesheetReportList: [],
  reportForSpecificJobList: [],
  reportForSpecificJobTotalCount: 0,
  totalWorkingHoursOnSpecificJob: "",
  timesheetSummaryReportList: [],
  timsheetSummaryReportTotal: "",
  billableSumTotal: 0,
  nonBillableSumTotal: 0,
  totalHoursSumTotal: 0,
  employeeWithoutFillTimesheetList: [],
  employeeWithoutFillTimesheetCount: 0,
  attendanceReportList: [],
  reportListCount: 0,
  allUserAttendanceReportList: [],
  singleAttendanceDetail: {},
  singleAttendanceDetailsHours: 0,
  singleFetching: false,
  allUserPayrollReportList: [],
  timesheetVsSchedulingMonthlyList: [],
  timesheetVsSchedulingMonthlyTotalCount: 0,
  clientWiseUserTimeSheetList: {
    billable_sum: 0,
    count: 0,
    data: [],
  } as ClientWiseUserTimeSheetType,
  clientWiseMonthlyTimesheetReportList: [],
  clientWiseMonthlyReportCount: 0,
  monthWiseTimesheetReportList: [],
  monthWiseTimesheetReportTotalCount: 0,
  timesheetReportTargetHours: 0,
  openJobChargedHoursTimesheetList: [],
  openJobChargedHoursTimesheetTotalSum: 0,
  enableBackdatedTimesheetEntry: false,
  regularizationCount: 0,
  userScheduledHoursData: {} as UserScheduledHoursDataType,
};
